import type { IconProps } from '#@/components/Icon';
import { COLOR } from '#@/shared/utils/styles';

import type { EnhancedCalloutType } from './types';

export const calloutTypeToIconTypeMap: Record<EnhancedCalloutType, IconProps['type'] | null> = {
  success: 'checkmark',
  warning: 'alert',
  info: 'info',
  danger: 'close',
  compactDefault: null,
  highlight: 'stars',
};

export const callOutTypeToColorMap: Record<EnhancedCalloutType, COLOR> = {
  success: COLOR.success,
  warning: COLOR.warning,
  info: COLOR.brand,
  danger: COLOR.danger,
  compactDefault: COLOR.textTertiary,
  highlight: COLOR.highlightNeon,
};
